import { Component, OnInit, Inject } from '@angular/core';
import { DialogData } from 'assets/angular-material-examples/dialog-data/dialog-data-example';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FromulariodespachoComponent } from 'app/components/servicio-medico/despacho/subdespacho/fromulariodespacho/fromulariodespacho.component';
import { ServiciosService } from 'app/services/servicios.service';

@Component({
  selector: 'app-csc-traslado',
  templateUrl: './csc-traslado.component.html',
  styleUrls: ['./csc-traslado.component.scss']
})
export class CscTrasladoComponent implements OnInit {

  public csctraslado;
  public csc;

  constructor(@Inject(MAT_DIALOG_DATA) private datos, private serviciosService: ServiciosService) { }

  ngOnInit() { 
  }

  enviar(){
    this.csc = this.datos.consec;
    this.serviciosService.cscTraslado(this.csc, this.csctraslado);
  }

}
